import { sendLog } from './send-log';

export const logger = {
  log({ type, data, message, pushId, date, ...additionalParams }) {
    const logData = {
      message,
      attributes: {
        pushId,
        hostname: `civitfun-checkin-web-${process.env.NODE_ENV}`,
        type,
        date,
        data,
        additionalParams,
      },
    };
    sendLog({ data: logData });
  },
};
